import { useEffect } from "react";
import { Grid, Button } from "@material-ui/core"
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { ToastMessage } from "../../../../global/ToastMessage";
import { actulizaBancoAction, obtenerBancosAllAction, nuevoBancoAction, targetBancoAction } from "../../../../ducks/bancoGeneralDuck"
import { onLoadAnction, offLoadAction } from "../../../../ducks/loadDuck"
import { useSelector } from "react-redux";
import { InitialValueBanco } from "../../InitialValueBanco";
import FieldMain from "../../../../global/FieldMain";
const validationSchema = yup.object({
    nombre: yup.string("Ingresa un nombre").required("Nombre es requerido"),
    tasaCobro: yup.number("Ingresa un apellido paterno").required("Tasa de cobro es requerido"),
})
const InitalValues = {
    nombre: "",
    tasaCobro: "",
}
const ArrayFormValues = [
    {
        name: "nombre",
        type: "text",
        label: "Nombre",
        width: "30%"
    },
    {
        name: "tasaCobro",
        type: "number",
        label: "Tasa de cobro %",
        width: "30%"
    },
]
const Form = () => {
    const { editar, bancoMain } = useSelector(store => store.bancoMain)
    const dispatch = useDispatch()
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => handleSubmit(values),
    })
    const handleSubmit = (values) => {
        let payload = {
            Nombre: values.nombre,
            TasaGeneral: values.tasaCobro,
        }
        dispatch(onLoadAnction({ message: "" }))
        if (editar) {
            payload.idBanco = bancoMain.IdBancoGeneral
            dispatch(actulizaBancoAction(payload)).then(Response => {
                dispatch(offLoadAction())
                if (Response.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema intentar mas tarde",
                    });
                    return null;
                }
                if (Response.status === 400) {
                    ToastMessage.fire({
                        icon: "error",
                        title: Response.Message,
                    });
                    return null;
                }
                dispatch(obtenerBancosAllAction())
                clearForm()
                ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                });
            })
        } else {
            dispatch(nuevoBancoAction(payload)).then(Response => {
                dispatch(offLoadAction())
                if (Response.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema intentar mas tarde",
                    });
                    return null;
                }
                if (Response.status === 400) {
                    ToastMessage.fire({
                        icon: "error",
                        title: Response.Message,
                    });
                    return null;
                }
                dispatch(obtenerBancosAllAction())
                clearForm()
                ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                });
            })
        }
    }

    useEffect(() => {
        const formLoad = () => {
            formik.setFieldValue("nombre", bancoMain?.Nombre)
            formik.setFieldValue("tasaCobro", bancoMain?.TasaGeneral)
        }
        if (editar)
            formLoad()
        else
            formik.resetForm(InitalValues)
    }, [editar, bancoMain.IdBancoGeneral]) //eslint-disable-line

    const handleCancel = () => {
        clearForm()
    }
    const clearForm = () => {
        formik.resetForm(InitalValues)
        dispatch(targetBancoAction({ banco: InitialValueBanco, editar: false}))
    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container>
                <Grid item xs={12}>
                    {
                        <h4 style={{textAlign: "center"}}>{(editar) ? "Editar Banco Principal" : "Nuevo Banco Principal"}</h4>
                    }
                </Grid>
                {
                    ArrayFormValues.map((item, index) =>
                        <Grid item xs={12} key={item.name}>
                            <FieldMain
                                name={item.name}
                                label={item.label}
                                type={item.type}
                                width={item.width}
                                formik={formik}
                            />
                        </Grid>
                    )
                }
                <Grid item xs={12}>
                    <div style={{display: "flex", flexFlow: "row", justifyContent: "center", alignItems: "center", gap: "1rem"}}>
                    <Button
                        style={{ margin: "0 2%" }}
                        variant="contained"
                        color="primary"
                        type="submit"
                    >
                        Guardar
                    </Button>
                    {
                        (editar) &&
                        <Button
                            style={{ margin: "0 2%" }}
                            variant="contained"
                            color="default"
                            onClick={handleCancel}
                        >
                            Camcelar
                        </Button>
                    }
                    </div>
                   
                </Grid>
            </Grid>
        </form>
    )
}
export default Form